import { isPhone } from 'base/utils/client';

export const theme = {
    useRem: false,
    siteSpace: isPhone ? 16 : 20,
    wrapperWidth: isPhone ? 375 : 1440,
    buttonTypes: ['default', 'primary', 'dashed', 'text', 'link', 'a', 'b', 'c', 'd', 'e', 'base', 'no-style'],
    placeholderColor: '#f4f4f4',
    defaultBgColor: '#EFEEED',
}